import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "../store"

interface ProfileState {
  selectedProfileId: string
}

const initialState: ProfileState = {
  selectedProfileId: "",
}

export const profileSlice = createSlice({
  name: "selectedProfileId",
  initialState,
  reducers: {
    setProfileId: (state, action: PayloadAction<string>) => {
      state.selectedProfileId = action.payload
    },
  },
})

export const { setProfileId } = profileSlice.actions
export const selectProfileId = (state: RootState) =>
  state.selectedProfile.selectedProfileId
export default profileSlice.reducer
